"use client";

import Link from "next/link";
import { FlaskConical, Sparkles } from "lucide-react";
import { IDX_LAUNCHLAB_CREATE_PATH } from "@/config/idxLaunchlabAppConfig";
import { IDX_CREATOR_CURVE_RATE_LABEL } from "@/lib/idx-launchlab/idx-cashback-display";

const launchCoinBtnClass =
  "inline-flex w-fit items-center justify-center gap-2 rounded-xl border border-emerald-500/40 bg-emerald-950/40 px-4 py-2.5 text-sm font-semibold text-emerald-100 shadow-sm shadow-emerald-950/30 transition hover:border-emerald-400/55 hover:bg-emerald-900/45 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/60 sm:px-5 sm:py-3";

export default function IdxVolumeBotCreatorPromo() {
  return (
    <div
      className="mt-4 rounded-xl border border-emerald-500/20 bg-emerald-950/20 p-4 sm:mt-5 sm:p-5"
      aria-labelledby="idx-volume-bot-creator-promo-heading"
    >
      <h2
        id="idx-volume-bot-creator-promo-heading"
        className="text-lg font-semibold leading-snug text-white sm:text-xl"
      >
        Launch your first coin on IDX Launchlab — earn creator fees on every
        trade
      </h2>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-gray-400 sm:text-base">
        Fair-launch on a bonding curve with no code. Creators earn{" "}
        <span className="font-medium text-emerald-300/90">
          {IDX_CREATOR_CURVE_RATE_LABEL}
        </span>{" "}
        on curve trades, then ongoing pool fees after graduation. Create your coin
        in minutes — no code required.
      </p>
      <div className="mt-4">
        <Link
          href={IDX_LAUNCHLAB_CREATE_PATH}
          className={launchCoinBtnClass}
          aria-label="Go to IDX Launchlab — launch a coin"
          rel="noopener noreferrer"
        >
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-emerald-900/50">
            <Sparkles className="h-4 w-4 text-emerald-300" aria-hidden />
          </span>
          Launch coin
          <FlaskConical className="h-4 w-4 shrink-0 text-emerald-400/80" aria-hidden />
        </Link>
      </div>
    </div>
  );
}
